import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "db-box-container-small-bottom overflow-x-unset",
    staticStyle: {
      "height": "150px"
    }
  }, [_vm.items && _vm.items.length && !_vm.isLoading ? _c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover"
    }, [_vm.packets ? _c('div', {
      staticClass: "info-heading",
      style: `color: ${_vm.timeColorFn()} !important;`
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      attrs: {
        "color": _vm.timeColorFn()
      }
    }, [_vm._v("fal fa-arrow-down")]), _vm._v("\n          " + _vm._s(_vm.infoProperty1 === 'source_time' ? _vm.timestampToTimeOnly(item[_vm.infoProperty1]) : item[_vm.infoProperty1]) + "\n        ")], 1) : _vm._e(), _c('div', {
      staticClass: "fmedium dyn-elipsis clickable",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(item);
        }
      }
    }, [_vm.property ? _c('span', [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${item.id}/details`
      }
    }, [_vm._v("\n              " + _vm._s(item[_vm.property]) + "\n            ")])], 1) : _c('span', [_vm._v("\n            " + _vm._s(item) + "\n          ")])])])]);
  }), 0) : _vm._e(), !_vm.items && !_vm.isLoading ? _c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list without-y-overflow",
    style: _vm.maxHeight ? 'max-height: fit-content; !important' : ''
  }, [_vm._t("default")], 2) : _vm._e(), _vm.items && !_vm.items.length && !_vm.isLoading ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n  ")], 1) : _vm._e(), _vm.isLoading ? _c('div', {
    staticClass: "centered-message"
  }, [_c('div', {
    staticClass: "sm-loading-position"
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": "#9f9c9cee"
    }
  })], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };